(function () {
  function norm(text) {
    return (text || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value || '').replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function hasProductControls(root) {
    return !!(root && root.querySelector && root.querySelector('form[action*="/cart/add"], product-form, variant-radios, variant-selects, .product-form__input'));
  }

  function getBuyBoxScope(trigger) {
    var scoped = trigger && trigger.closest('product-info, .product, .product__info-container, main .shopify-section[id*="product"]');
    if (hasProductControls(scoped)) return scoped;

    var buybox = trigger && trigger.closest('.bt-v2-buybox');
    if (buybox) {
      var section = buybox.closest('.shopify-section, main, body');
      if (hasProductControls(section)) return section;
    }

    var fallback = document.querySelector('product-info, .product, .product__info-container, main .shopify-section[id*="product"]');
    return hasProductControls(fallback) ? fallback : null;
  }

  function scrollToBuyBox(trigger) {
    var scope = getBuyBoxScope(trigger);
    var target = scope && scope.querySelector ? scope.querySelector('product-info, .product__info-container, form[action*="/cart/add"]') : null;
    if (!target) target = document.querySelector('product-info, .product__info-container, form[action*="/cart/add"]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }
    return false;
  }

  function selectVariantByText(optionText, trigger) {
    var wanted = norm(optionText);
    if (!wanted) return false;
    var matched = false;
    var scope = getBuyBoxScope(trigger);
    if (!scope) return false;
    var queryRoot = scope;

    queryRoot.querySelectorAll('variant-radios input[type="radio"], variant-selects input[type="radio"], .product-form__input input[type="radio"], product-info input[type="radio"]').forEach(function (input) {
      var label = input.id ? queryRoot.querySelector('label[for="' + cssEscape(input.id) + '"]') || document.querySelector('label[for="' + cssEscape(input.id) + '"]') : null;
      var labelText = label ? label.textContent : input.value;
      var combined = norm(labelText + ' ' + input.value + ' ' + (input.name || ''));
      if (combined.indexOf(wanted) !== -1 || wanted.indexOf(norm(input.value)) !== -1) {
        if (!input.checked) input.click();
        matched = true;
      }
    });

    if (!matched) {
      queryRoot.querySelectorAll('variant-selects select, .product-form__input select, product-info select, form[action*="/cart/add"] select').forEach(function (select) {
        Array.prototype.slice.call(select.options).forEach(function (option) {
          var combined = norm(option.text + ' ' + option.value);
          if (combined.indexOf(wanted) !== -1) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            matched = true;
          }
        });
      });
    }

    scrollToBuyBox(trigger);
    return matched;
  }

  function addPlanToUrl(url, plan) {
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('bt_plan', plan);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (err) {
      var glue = url.indexOf('?') === -1 ? '?' : '&';
      return url + glue + 'bt_plan=' + encodeURIComponent(plan);
    }
  }

  function applyPlanFromUrl() {
    try {
      var plan = new URLSearchParams(window.location.search).get('bt_plan');
      if (!plan) return;
      window.setTimeout(function () { selectVariantByText(plan, document.body); }, 140);
    } catch (err) {}
  }

  document.addEventListener('click', function (event) {
    var scrollBuybox = event.target.closest('[data-bt-v2-scroll-buybox]');
    if (scrollBuybox) {
      event.preventDefault();
      scrollToBuyBox(scrollBuybox);
      return;
    }

    var optionButton = event.target.closest('[data-bt-v2-option]');
    if (optionButton) {
      var optionHref = optionButton.getAttribute('href');
      var productScope = getBuyBoxScope(optionButton);
      if (!productScope && optionHref) return;
      event.preventDefault();
      var selected = selectVariantByText(optionButton.getAttribute('data-bt-v2-option'), optionButton);
      if (!selected && optionHref) window.location.href = optionHref;
      return;
    }

    var stickyButton = event.target.closest('[data-bt-v2-add-to-cart]');
    if (stickyButton) {
      var addScope = getBuyBoxScope(stickyButton) || document;
      var addButton = addScope.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"], .product-form__submit') || document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"], .product-form__submit');
      if (addButton && !addButton.disabled) {
        event.preventDefault();
        addButton.click();
      }
    }
  });

  applyPlanFromUrl();

  var stickyBars = Array.prototype.slice.call(document.querySelectorAll('.bt-v2-sticky'));
  if (stickyBars.length) {
    document.body.classList.add('bt-v2-has-sticky');
    var revealAt = 420;
    function updateSticky() {
      stickyBars.forEach(function (bar) {
        if (window.scrollY > revealAt) bar.classList.add('is-visible');
        else bar.classList.remove('is-visible');
      });
    }
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
  }
})();


(function () {
  var DOSES = {
    dog: [
      { label: '1–2 lb (0.5–0.9 kg)', min: 0.25, max: 0.25 },
      { label: '3–5 lb (1.4–2.3 kg)', min: 0.5, max: 0.5 },
      { label: '6–10 lb (2.7–4.5 kg)', min: 1, max: 1 },
      { label: '11–15 lb (5.0–6.8 kg)', min: 1.5, max: 1.5 },
      { label: '16–20 lb (7.3–9.1 kg)', min: 2, max: 2 },
      { label: '21–25 lb (9.5–11.3 kg)', min: 2.5, max: 2.5 },
      { label: '26–30 lb (11.8–13.6 kg)', min: 3, max: 3 },
      { label: '31–35 lb (14.1–15.9 kg)', min: 3.5, max: 3.5 },
      { label: '36–40 lb (16.3–18.1 kg)', min: 4, max: 4 },
      { label: '41–45 lb (18.6–20.4 kg)', min: 4.5, max: 4.5 },
      { label: '46–50 lb (20.9–22.7 kg)', min: 5, max: 5 },
      { label: '51–55 lb (23.1–24.9 kg)', min: 5.5, max: 5.5 },
      { label: '56–60 lb (25.4–27.2 kg)', min: 6, max: 6 },
      { label: '61–100 lb (27.7–45.4 kg)', min: 6, max: 8 },
      { label: '100+ lb (≥45.4 kg)', min: 6, max: 8 }
    ],
    cat: [
      { label: '1–2 lb (0.5–0.9 kg)', min: 0.25, max: 0.25 },
      { label: '3–5 lb (1.4–2.3 kg)', min: 0.5, max: 0.5 },
      { label: '6–10 lb (2.7–4.5 kg)', min: 1, max: 1 },
      { label: '11–15 lb (5.0–6.8 kg)', min: 1.5, max: 1.5 },
      { label: '16–20 lb (7.3–9.1 kg)', min: 2, max: 2 },
      { label: '21–25 lb (9.5–11.3 kg)', min: 2, max: 2 },
      { label: '26–30 lb (11.8–13.6 kg)', min: 2, max: 2 },
      { label: '30+ lb (≥13.6 kg)', min: 2, max: 2 }
    ]
  };
  var CAPS_PER_BOTTLE = 60;
  var DEFAULT_I18N = {
    frequencyMild: '1 time daily',
    frequencyStrong: '2 times daily',
    capsuleOne: '[amount] capsule',
    capsuleOther: '[amount] capsules',
    bottleOne: '[amount] bottle',
    bottleOther: '[amount] bottles',
    dailyTotal: '[amount] / day',
    plan1Copy: 'Best as a low-commitment first order.',
    plan5Label: '5 bottles + 1 free',
    plan5Copy: 'Best match for a practical 3-month routine when total need is up to 6 bottles.',
    plan10Label: '10 bottles + 2 free',
    plan10Copy: 'Best match for higher daily amounts or a longer first plan.',
    plan20Label: '20 bottles + 5 free',
    plan20Copy: 'Best match for long-term routines, repeat buyers, or multi-pet homes.',
    planReorderLabel: '20 bottles + 5 free, then reorder as needed',
    planReorderCopy: 'This routine may require more than one large bundle over time.',
    modeNoteMild: 'Mild Mode uses the selected per-dose amount once daily.',
    modeNoteStrong: 'Strong Mode uses the selected per-dose amount twice daily: morning and evening.',
    doseLabels: {}
  };

  function getI18n(root) {
    var i18n = {};
    try {
      i18n = JSON.parse(root.getAttribute('data-bt-v31-i18n') || '{}') || {};
    } catch (err) {
      i18n = {};
    }
    Object.keys(DEFAULT_I18N).forEach(function (key) {
      if (i18n[key] === undefined || i18n[key] === null || i18n[key] === '') i18n[key] = DEFAULT_I18N[key];
    });
    i18n.doseLabels = i18n.doseLabels || {};
    return i18n;
  }

  function template(text, amount) {
    return String(text || '').replace('[amount]', amount);
  }

  function unitText(i18n, amount, singularKey, pluralKey, plural) {
    return template(i18n[plural ? pluralKey : singularKey], amount);
  }

  function fmtNumber(value) {
    var whole = Math.floor(value);
    var frac = Math.round((value - whole) * 100);
    if (frac === 0) return String(whole);
    var glyph = frac === 25 ? '¼' : (frac === 50 ? '½' : (frac === 75 ? '¾' : String(value)));
    return whole === 0 ? glyph : String(whole) + glyph;
  }
  function fmtCaps(i18n, min, max) {
    var text = (min === max) ? fmtNumber(min) : (fmtNumber(min) + '–' + fmtNumber(max));
    return unitText(i18n, text, 'capsuleOne', 'capsuleOther', max > 1);
  }
  function ceilBottles(caps) { return Math.ceil(caps / CAPS_PER_BOTTLE); }
  function bottleText(i18n, minCaps, maxCaps) {
    var a = ceilBottles(minCaps), b = ceilBottles(maxCaps);
    return unitText(i18n, a === b ? String(a) : (a + '–' + b), 'bottleOne', 'bottleOther', b > 1);
  }
  function planFor(i18n, bottles) {
    if (bottles <= 1) return { option: '1 bottle', label: unitText(i18n, '1', 'bottleOne', 'bottleOther', false), copy: i18n.plan1Copy };
    if (bottles <= 6) return { option: '5 bottles', label: i18n.plan5Label, copy: i18n.plan5Copy };
    if (bottles <= 12) return { option: '10 bottles', label: i18n.plan10Label, copy: i18n.plan10Copy };
    if (bottles <= 25) return { option: '20 bottles', label: i18n.plan20Label, copy: i18n.plan20Copy };
    return { option: '20 bottles', label: i18n.planReorderLabel, copy: i18n.planReorderCopy };
  }
  function updateCardStates(root) {
    root.querySelectorAll('[data-bt-v31-mode-card]').forEach(function (card) {
      var input = card.querySelector('input');
      card.classList.toggle('is-selected', !!(input && input.checked));
    });
  }
  function setupCalculator(root) {
    var petInputs = root.querySelectorAll('input[name^="bt_v31_pet_"]');
    var modeInputs = root.querySelectorAll('input[name^="bt_v31_mode_"]');
    var weight = root.querySelector('[data-bt-v31-weight]');
    if (!weight) return;
    var i18n = getI18n(root);
    function pet() { var checked = root.querySelector('input[name^="bt_v31_pet_"]:checked'); return checked ? checked.value : 'dog'; }
    function mode() { var checked = root.querySelector('input[name^="bt_v31_mode_"]:checked'); return checked ? checked.value : 'mild'; }
    function populateWeights() {
      var rows = DOSES[pet()] || DOSES.dog;
      var current = weight.value;
      weight.innerHTML = '';
      rows.forEach(function (row, idx) {
        var opt = document.createElement('option');
        opt.value = String(idx);
        opt.textContent = i18n.doseLabels[row.label] || row.label;
        weight.appendChild(opt);
      });
      if (current && rows[Number(current)]) weight.value = current;
    }
    function setText(sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; }
    function calculate() {
      var rows = DOSES[pet()] || DOSES.dog;
      var row = rows[Number(weight.value)] || rows[0];
      var times = mode() === 'strong' ? 2 : 1;
      var minDaily = row.min * times;
      var maxDaily = row.max * times;
      setText('[data-bt-v31-per-dose]', fmtCaps(i18n, row.min, row.max));
      setText('[data-bt-v31-frequency]', mode() === 'strong' ? i18n.frequencyStrong : i18n.frequencyMild);
      setText('[data-bt-v31-daily-total]', template(i18n.dailyTotal, fmtCaps(i18n, minDaily, maxDaily)));
      setText('[data-bt-v31-bottles-30]', bottleText(i18n, minDaily * 30, maxDaily * 30));
      setText('[data-bt-v31-bottles-90]', bottleText(i18n, minDaily * 90, maxDaily * 90));
      setText('[data-bt-v31-bottles-180]', bottleText(i18n, minDaily * 180, maxDaily * 180));
      var recBottles = ceilBottles(maxDaily * 90);
      var plan = planFor(i18n, recBottles);
      setText('[data-bt-v31-recommendation]', plan.label);
      setText('[data-bt-v31-recommendation-copy]', plan.copy);
      var note = root.querySelector('[data-bt-v31-mode-note]');
      if (note) note.textContent = mode() === 'strong' ? i18n.modeNoteStrong : i18n.modeNoteMild;
      var link = root.querySelector('[data-bt-v31-shop-link]');
      if (link) {
        var planOption = plan.option;
        link.setAttribute('data-bt-v2-option', planOption);
        var baseHref = link.getAttribute('data-bt-v31-base-href') || link.getAttribute('href') || '/products/tcmvetbaituxiao';
        link.setAttribute('data-bt-v31-base-href', baseHref);
        try {
          var parsed = new URL(baseHref, window.location.origin);
          parsed.searchParams.set('bt_plan', planOption);
          link.setAttribute('href', parsed.pathname + parsed.search + parsed.hash);
        } catch (err) {
          var glue = baseHref.indexOf('?') === -1 ? '?' : '&';
          link.setAttribute('href', baseHref + glue + 'bt_plan=' + encodeURIComponent(planOption));
        }
      }
      updateCardStates(root);
    }
    petInputs.forEach(function (input) { input.addEventListener('change', function () { populateWeights(); calculate(); }); });
    modeInputs.forEach(function (input) { input.addEventListener('change', calculate); });
    weight.addEventListener('change', calculate);
    populateWeights();
    calculate();
  }
  document.querySelectorAll('[data-bt-v31-calculator]').forEach(setupCalculator);
})();
